import React from 'react'
import { RowLayout } from '../RowLayout'

import {
  auxAffectedPersonCode,
  getAffectedPersonCode,
} from '../../helpers'
import {
  AttachmentType,
  CaseCommonDataType,
  CaseTIRespType,
  LookupItemType,
} from '../../models'
import { strToDateFormat } from '../../helpers'
import { OverviewRowAttachments } from './OverviewRowAttachments'
import { translation } from '../../i18n'
import { priceFormat } from '../../helpers/miscFunctions'

export type ticketOverviewRespType = {
  caseCommon?: CaseCommonDataType
  caseTI?: CaseTIRespType
} & translation

export const TicketOverview = (params: ticketOverviewRespType) => {
  const t = params.t
  const reasons: LookupItemType[] = t(`reasons`) as any // lookup
  const relations: LookupItemType[] = t(`relations`) as any // lookup
  return (
    <>
      <RowLayout
        text={t('ticketForm.event.label')}
        data={params.caseTI?.eventName}
      />
      <RowLayout
        text={t('ticketForm.cancellationDate.label')}
        data={strToDateFormat(params.caseCommon?.occurredOn)}
      />
      <RowLayout
        text={t('ticketForm.reason.label')}
        data={
          reasons.find(
            (lookupItem) => lookupItem.code === params.caseTI?.reason
          )?.name
        }
      />
      <RowLayout
        text={t('ticketForm.affectedPerson.label')}
        // @ts-ignore
        data={
          getAffectedPersonCode(params.caseTI?.insuredRelation) ===
            auxAffectedPersonCode
            ? relations.find(
              (lookupItem) =>
                lookupItem.code === params.caseTI?.insuredRelation
            )?.name
            : t(
              `ticketForm.affectedPerson.code.${params.caseTI?.insuredRelation}`
            )
        }
      />
      {params.caseCommon?.description !== '' && (
        <RowLayout
          text={t('ticketForm.description.label')}
          data={params.caseCommon?.description}
        />
      )}
      <RowLayout
        text={t('cancellationPg.priceCur.label')}
        data={priceFormat({
          price: params.caseTI?.priceCur,
          currency: params.caseTI?.currency,
        })}
      />
      <OverviewRowAttachments
        text={t('attachments.CASETI.SUPPORT')}
        attachmentList={params.caseTI?.attachmentList}
        attachmentType={AttachmentType.SUPPORT}
      />
      <OverviewRowAttachments
        text={t('attachments.CASETI.PHOTO')}
        attachmentList={params.caseTI?.attachmentList}
        attachmentType={AttachmentType.PHOTO}
      />
    </>
  )
}
